import React, { Component, createRef } from 'react';
import * as GCodePreview from 'gcode-preview';
import axios from 'axios'
import { debounce } from 'lodash';
import { Button, Card, Table, Spinner, Modal } from 'react-bootstrap'
import { connect } from 'react-redux';

class GCodeViewer extends Component {
  canvasRef = createRef();
  preview = null;

  state = {
    totalLayers: 0,
    layerSelected: 0,
    layers: [],
    loading: false
  }

  componentDidMount() {
    if (!this.canvasRef.current) return;

    this.preview = GCodePreview.init({
      canvas: this.canvasRef.current,
      buildVolume: { x: 200, y: 200, z: 200 },
      renderExtrusion: true,
      renderTravel: true,
      renderTubes: true
    });
    this.setState({ loading: true })
    axios.post("/api/jobs/get/gcode/as/string", { job: this.props.jobDraft._id }).then(async res => {
      await this.preview.processGCode(res.data.gcode)
      const match = res.data.gcode.match(/; total layers count = (\d+)/);
      const totalLayers = match ? parseInt(match[1], 10) : 0;
      const layers = this.splitGcodeByLayer(res.data.gcode);
      this.setState({ totalLayers: totalLayers, layerSelected: totalLayers, layers: layers, loading: false }, () => {
        this.updateLayers(totalLayers)

      })
    })
  }
  updateLayer = (e) => {
    this.updateLayers(e.target.value)
  };
  debouncedRenderLayers = debounce((layerIndex) => {
    if (!this.state.layers) return;

    this.preview.clear();
    const layersToShow = this.state.layers.slice(0, layerIndex);
    this.preview.processGCode(layersToShow.join('\n'));
  }, 100)
  updateLayers = (nu) => {
    const layerIndex = parseInt(nu, 10);
    this.setState({ layerSelected: layerIndex });

    this.debouncedRenderLayers(layerIndex)
  }


  splitGcodeByLayer = (gcode) => {
    const lines = gcode.split('\n');
    const layers = [];
    let currentLayer = null; // don't start until first LAYER_CHANGE

    lines.forEach(line => {
      if (line.startsWith(';LAYER_CHANGE')) {
        if (currentLayer) {
          layers.push(currentLayer.join('\n'));
        }
        currentLayer = [line]; // start new layer
      } else if (currentLayer) {
        currentLayer.push(line); // only record if a layer has started 
      }
    });

    // Push last layer
    if (currentLayer) layers.push(currentLayer.join('\n'));

    return layers;
  };
  componentWillUnmount() {
    if (this.preview) {
      this.preview.clear();
      this.preview = null;
    }
  }

  render() {
    let darkmode = this.props.user ? this.props.user.darkmode : true

    return (
      <div>

        <canvas
          ref={this.canvasRef}
          style={{ width: '100%', height: '500px' }}
        />
        <input
          type="range"
          min="0"
          max={this.state.totalLayers}
          value={this.state.layerSelected}
          onChange={this.updateLayer}
          style={{ width: '100%', padding: "0" }}
        />
        <p>
          {this.state.layerSelected} / {this.state.totalLayers} Layers
        </p>
        {
          this.state.loading && <Modal contentClassName="rounded-4 overflow-hidden bg-transparent border-0" style={{ borderRadius: "20px" }} centered show={this.state.loading}>

            <Modal.Body style={{ margin: "auto", width: "100%", textAlign: "center", borderRadius: "20px" }} className={darkmode ? "darkmode-card-content" : "lightmode-card-content"}>

              <Spinner animation="border" vaiant="secondary" style={{ width: '50px', height: '50px', fontSize: '30px', margin: "auto", textAlign: "center" }} />
            </Modal.Body>

          </Modal>
        }
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    user: state.user,
    jobDraft: state.jobDraft

  }
}
function mapDispatchToProps(dispatch) {
  return {
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(GCodeViewer);